import React from "react"
import PropTypes from "prop-types"
import Radium, { keyframes } from "higher-order-components/configured-radium/"

const AnimatedDropdown = ({ open, children }) =>
  (open ? (
    <div style={styles.sidebarWrapper}>
      <div style={styles.transform}>{children}</div>
    </div>
  ) : null)

const foldIn = keyframes({
  "0%": {
    transform: "rotateX(30deg)"
  },
  "40%": {
    transform: "rotateX(-5deg)" // overshoot target to create bounce effect
  },
  "75%": {
    transform: "rotateX(2.5deg)"
  },
  "100%": {
    transform: "rotateX(0deg)"
  }
})

AnimatedDropdown.propTypes = {
  open: PropTypes.bool,
  children: PropTypes.node
}

export default Radium(AnimatedDropdown)

const styles = {
  sidebarWrapper: {
    pointerEvents: "all",
    perspective: "5000px",
    width: "100%"
  },
  transform: {
    transformOrigin: "top",
    // animation: 'x .666s',
    // animationName: foldIn,
    transform: "rotateX(0deg)"
  }
}



// WEBPACK FOOTER //
// ./src/containers/mymazda/navigation/animated-dropdown.jsx